import React from 'react';

import {
  Box,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

const DelegationsSkeleton = (): JSX.Element => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="start"
      height="100%"
    >
      <Box mb={4}>
        <Skeleton variant="text" animation="wave" height={30} />
        <Skeleton variant="text" animation="wave" height={20} />
      </Box>

      <Paper>
        <Box p={2}>
          <Box mb={4}>
            <Skeleton variant="text" height="30px" />
          </Box>
          <TableContainer
            component={Paper}
            style={{ minHeight: '380px', height: '100%' }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="right">
                    <Skeleton variant="rectangular" />
                  </TableCell>
                  <TableCell align="right">
                    <Skeleton variant="rectangular" />
                  </TableCell>
                  <TableCell align="right">
                    <Skeleton variant="rectangular" />
                  </TableCell>
                  <TableCell align="right">
                    <Skeleton variant="rectangular" />
                  </TableCell>
                  <TableCell align="right">
                    <Skeleton variant="rectangular" />
                  </TableCell>
                  <TableCell align="right">
                    <Skeleton variant="rectangular" />
                  </TableCell>
                  <TableCell align="right">
                    <Skeleton variant="rectangular" />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.from({ length: 8 }, (_, i) => i + 1).map((i) => (
                  <TableRow key={i}>
                    <TableCell align="right">
                      <Skeleton variant="text" />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Paper>
    </Box>
  );
};

export default DelegationsSkeleton;
